import React, { Component } from 'react';
import { Icon } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

class RequirementDescribe extends Component {
    state = {
        expand: false,
        requirementDescribe: undefined,
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.visible !== this.props.visible) {
            this.loadData();
        }
        if (prevProps.visible && !this.props.visible) {
            this.setState({ expand: false });
        }
    }

    loadData = () => {
        const { investigationId } = this.props;
        const options = {
            url: API_URL.member.queryByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { requirementDescribe } = res.data || {};
                this.setState({ requirementDescribe });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    handleClick = () => {
        this.setState(prevState => ({ expand: !prevState.expand }));
    }

    render() {
        const { expand, requirementDescribe } = this.state;

        return (
            <div style={{ marginTop: 6 }}>
                <a onClick={this.handleClick}>
                    <Icon className="expand-icon" type={expand ? "up" : "down"} />
                    项目需求描述
                </a>
                { expand && <div style={{ marginTop: 6, padding: 10, color: '#666', border: '1px solid #D1D1D1', borderRadius: 3, whiteSpace: 'pre-wrap' }}>{requirementDescribe}</div> }
            </div>
        );
    }
}

export default RequirementDescribe;


// WEBPACK FOOTER //
// ./src/components/user/require/components/RequirementDescribe.js